"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@mui/styles");
const useStyles = exports.useStyles = (0, _styles.makeStyles)(() => ({
  columnsContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    textAlign: "left"
  },
  footerColumn: {
    "& primary": {
      flex: "auto !important",
      width: "100% !important"
    }
  }
}));